module.exports = __webpack_public_path__ + "static/media/USM.2b9f0b44.png";